export default "__VITE_ASSET__Ir8RZTSL__"